const stringifyError = (error) => {
    return typeof error === 'object' ? error.toString() : error;
};
export default stringifyError;
//# sourceMappingURL=stringifyError.js.map